import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { getDatabase, ref, get, update, equalTo, orderByChild, query, push, set, onValue, remove } from 'firebase/database';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import { useAuth } from '../../../Context/AuthContext';

export interface Bonus {
    titleBonus: string;
    email: string;
    amount: string;
    bonusDate: string;
    created_by: string;
    created_at: Date;
}
const ExtraBonus = () => {
  const db = getDatabase();
  const [bonuses, setBonuses] = useState<Bonus[]>([]);
  const { handleSubmit, register } = useForm<Bonus>({});
  const [reportDate, setReportMonth] = useState(new Date());
  const { user } = useAuth();

  useEffect(() => {
    setBonuses([])
    const fetchAllBonuses = async () => {
        const month = reportDate.getUTCMonth() + 1;
        const year = reportDate.getUTCFullYear();
        const bonusRef = ref(db, `extraBonus/${year}/${month}`);
        onValue(bonusRef, (snapshot) => {
            const bonusData = snapshot.val();
            console.log({bonusData})
            const allBonuses: Bonus[] = [];

            if (bonusData) {
                Object.keys(bonusData).map((key) => {
                  bonusData[key].map((e: any) => {
                    allBonuses.push(e)
                  })
                })
                console.log({allBonuses})

                setBonuses(allBonuses);
            }
        });
    };

    fetchAllBonuses();
}, [db, reportDate]);

  const onSubmit = async (data: Bonus) => {
    const year = reportDate.getUTCFullYear();
    const month = reportDate.getUTCMonth() + 1; // Months are zero-based, so add 1
    const day = reportDate.getUTCDate();
    const dateString = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;

    const formattedData = {
        titleBonus: data.titleBonus,
        amount: data.amount,
        bonusDate: dateString,
        email: data.email,
        created_by: user?.email,
        created_at: Date.now()
    };


    const usersRef = ref(db, 'users');
    const userQuery = query(usersRef, orderByChild('email'), equalTo(data.email));
    const userSnapshot = await get(userQuery);

    if (userSnapshot.exists()) {
      const userId = Object.keys(userSnapshot.val())[0]; 

      try {
          const bonusRef = ref(db, `extraBonus/${year}/${month}/${userId}`);

          const snapshot = await get(bonusRef);
          const existingBonuses = snapshot.exists() ? snapshot.val() : [];

          existingBonuses.push(formattedData);

          await set(bonusRef, existingBonuses);

          console.log("New bonus data added successfully!");
      } catch (error) {
          console.error("Error adding new bonus data:", error);
      }
  } else {
      console.log("No user found with the provided email.");
  }

  };

  const deleteBonus = async (email: string, title: string) => {
    const usersRef = ref(db, 'users');
    const userQuery = query(usersRef, orderByChild('email'), equalTo(email));
    const userSnapshot = await get(userQuery);
  
    if (userSnapshot.exists()) {
      const userId = Object.keys(userSnapshot.val())[0];
      const month = reportDate.getUTCMonth() + 1;
      const year = reportDate.getUTCFullYear();
      const bonusRef = ref(db, `extraBonus/${year}/${month}/${userId}`);
  
      try {
        const bonusSnapshot = await get(bonusRef);
  
        if (bonusSnapshot.exists()) {
          let bonuses = bonusSnapshot.val();
          const bonusIndex = bonuses.findIndex(
            (bonus: Bonus) => bonus.email === email && bonus.titleBonus === title
          );

          if (bonusIndex !== -1) {
            bonuses.splice(bonusIndex, 1);

            await set(bonusRef, bonuses);

            console.log("Bonus data deleted successfully!");

            setBonuses(prevBonuses =>
              prevBonuses.filter(
                bonus => !(bonus.email === email && bonus.titleBonus === title)
              )
            );
          } else {
            console.error("Bonus with the specified email and title does not exist.");
          }
        } else {
          console.error("Bonus data does not exist for the specified user and date.");
        }
      } catch (error) {
        console.error("Error deleting bonus data:", error);
      }
    } else {
      console.error("User with email does not exist.");
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ textAlign: 'center' }}>
          {/* <b className="smallTitle">Sale interval</b> */}
          <br></br>
          <b className="text">
            {' '}
            <DatePicker
            onlyMonthPicker
            format="MMMM YYYY"
            onChange={(data) => {
                // @ts-ignore
                if (data) {
                const date = (data as DateObject).toDate();
                date.setHours(24);
                setReportMonth(date);
                }
            }}
            value={reportDate}
            minDate="2022/12/01"
            style={{
                border: '1px solid var(--primaryColor)',
                height: '35px',
                width: '280px',
                textAlign: 'center',
                fontSize: '1rem',
            }}
            />
          </b>
        </div>
        <Table hover responsive bordered>
          <thead style={{ borderWidth: 'thin' }}>
            <tr>
              <th>Bonus Title</th>
              <th>Email</th>
              <th>Amount (RM)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
                <td>
                    <input {...register('titleBonus')} />
                </td>
                <td>
                    <input {...register('email')} />
                </td>
                <td>
                    <input {...register('amount')} />
                </td>
            </tr>
          </tbody>
        </Table>
        {/* <button
          style={{
            color: 'var(--secondaryColor)',
            backgroundColor: 'var(--primaryColor)',
            border: '1px solid var(--primaryColor)',
            padding: '7px',
            borderRadius: '10px',
            float: 'left',
          }}
          type="submit"
        >
          Add Combo
        </button> */}

        {/* <div
          style={{
            marginBottom: '100px',
          }}
        ></div> */}
        <button
          style={{
            color: 'var(--secondaryColor)',
            backgroundColor: 'var(--primaryColor)',
            border: '1px solid var(--primaryColor)',
            padding: '7px',
            borderRadius: '10px',
            float: 'right',
          }}
          type="submit"
        >
          Submit
        </button>
      </form>
      <br />
      <br />
      <br />
      <div>
      <Table hover responsive bordered>
        <thead>
            <tr>
                <th>Bonus Title</th>
                <th>Email</th>
                <th>Amount (RM)</th>
                <th>Date</th>
                <th>Created By</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            {bonuses.length > 0 ? (
                bonuses.map((bonus, index) => (
                    <tr key={index}>
                        <td>{bonus.titleBonus}</td>
                        <td>{bonus.email}</td>
                        <td>{bonus.amount}</td>
                        <td>{bonus.bonusDate}</td>
                        <td>{bonus.created_by}</td>
                        <td><button onClick={() => deleteBonus(bonus.email, bonus.titleBonus)}>Delete</button></td>
                    </tr>
                ))
            ) : (
                <tr>
                    <td colSpan={5}>No data available</td>
                </tr>
            )}
        </tbody>
    </Table>
      </div>
    </>
  );
};

export default ExtraBonus;
